import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router';
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl';
import cx from 'classnames';
import Field from 'redux-form/es/Field';
import Button from 'components/common/Button';
import InputField from 'components/Credit24/Core/Controls/InputField';
import AuthenticationErrorMessage from 'components/common/AuthenticationErrorMessage';

const propTypes = {
  authentication: PropTypes.object.isRequired,
  toggleRecoveryPasswordScreen: PropTypes.func.isRequired,
};

const recoveryPasswordLinkText = <FormattedMessage id="login.forgot_password.link" />;

const LoginForm = (props) => {
  const { authentication, toggleRecoveryPasswordScreen } = props;
  const { isLoading } = authentication;
  const authenticationError = authentication.errorMessage
    || authentication.exception || authentication.errorCode;
  const recoveryPasswordLinkClasses = cx({
    'txt-center txt-larger': authenticationError,
    'txt-right': !authenticationError,
  });
  return (
    <>
      <AuthenticationErrorMessage authentication={authentication} />
      <Field
        title={<FormattedMessage id="login.field.username" />}
        name="username"
        component={InputField}
        disabled={isLoading}
        isFullWidth
        forcedErrorOnSubmit
      />
      <Field
        title={<FormattedMessage id="login.field.password" />}
        name="login_pass"
        type="password"
        component={InputField}
        disabled={isLoading}
        isTextButton
        isFullWidth
        forcedErrorOnSubmit
      />
      <p className={recoveryPasswordLinkClasses}>
        <Link to="password-reset" onClick={toggleRecoveryPasswordScreen}>
          {authenticationError
            ? <strong>{recoveryPasswordLinkText}</strong>
            : recoveryPasswordLinkText}
        </Link>
        <br />
        <br />
      </p>
      <Button
        isLoading={isLoading}
        disabled={isLoading}
        isFullWidth
      >
        <FormattedMessage id="login.buttons.login" />
      </Button>
      <div className="txt-center">
        <FormattedHTMLMessage tagName="p" id="login.legacy.text" />
        <a href="https://www.credit24.com.au/loginTab.html">
          <FormattedMessage id="login.legacy.link.text" />
        </a>
      </div>
    </>
  );
};

LoginForm.propTypes = propTypes;

export default LoginForm;
